<template>
  <table class="table table-hover table-striped">
    <thead>
      <tr>
        <th>Datum</th>
        <th>Elförbrukning</th>
        <th>Postnummer</th>
        <th>
          IP-adress

          <small class="ml-1 text-muted" v-b-tooltip.hover title="The earning is registered when user that visited TecknaEl website from affiliate performs search (electricity comparison). Important note: we count only unique searches, for example, if one user visited TecknaEl and performed 3 different searches, only one earning will be registered.">
            <font-awesome-icon icon="question-circle" />
          </small>
        </th>
        <th>Kostnad</th>
      </tr>
    </thead>

    <tbody v-if="earnings.length > 0">
      <tr v-for="earning in earnings">
        <td class="align-middle">
          <small>
            {{ dayMonthYear(earning.created_at) }}
          </small>
        </td>
        <td class="align-middle">
          <small>
            {{ earning.search_data.power_consumption }}
          </small>
        </td>
        <td class="align-middle">
          <small>
            {{ earning.search_data.postal_code }}
          </small>
        </td>
        <td class="align-middle">
          <div>
            <small>
              {{ earning.search_data.ip_address }}
            </small>
          </div>

          <div v-if="earning.search_data.amount > 1">
            <small>
              <small class="text-muted">
                Sökningar från denna IP-adress: <span class="badge badge-secondary">{{ earning.search_data.amount }}</span>
              </small>
            </small>
          </div>
        </td>
        <td class="align-middle">
          <small>
            {{ earning.cost }} kr
            <small class="text-muted">
              (ex. moms)
            </small>
          </small>
        </td>
      </tr>
    </tbody>

    <tbody v-else>
      <tr>
        <td colspan="5" class="text-center text-muted">
          Du har inget att fakturera för nuvarande fakturaperiod
        </td>
      </tr>
    </tbody>

  </table>
</template>

<script>

  import DateMixin from "../../../../app/mixins/helpers/DateMixin"

  export default {
    name: "SearchEarnings",
    mixins: [
      DateMixin
    ],
    props: {
      earnings: {
        required: true,
        format: Array
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Earnings/Partials/Search.vue